import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import Layout from '../components/layout/Layout';
import ClientForm from '../components/clients/ClientForm';
import { DEFAULT_CLIENT } from '../utils/clientModel';
import { clientApi } from '../services/api';

const AddClientPage = () => {
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (values) => {
    setIsLoading(true);
    
    try {
      // Format dates properly
      const formattedValues = {
        ...values,
        lastContact: values.lastContact ? new Date(values.lastContact).toISOString() : '',
        nextFollowUp: values.nextFollowUp ? new Date(values.nextFollowUp).toISOString() : '',
      };
      
      // Add client via API
      await clientApi.create(formattedValues);
      
      toast.success('Client added successfully!');
      navigate('/');
    } catch (error) {
      toast.error('Failed to add client. Please try again.');
      console.error('Error adding client:', error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Layout>
      <div className="mb-4">
        <h2>Add New Client</h2>
        <p className="text-muted">Fill in the client details below</p>
      </div>
      <ClientForm 
        client={DEFAULT_CLIENT} 
        onSubmit={handleSubmit} 
        isLoading={isLoading} 
      />
    </Layout>
  );
};

export default AddClientPage;
